import { IsInt, IsNotEmpty, IsNumber, IsPositive } from 'class-validator';

export class RequestOperationDto {
  @IsInt()
  @IsNotEmpty()
  deviceId: number;

  @IsNumber()
  @IsPositive()
  amount: number; // The count/drop amount
}